import { HttpStatusCode, LoadingStatusType, UserType } from "@/enums/enums";
import { i18n } from "@/i18n";
import API from "@/service/Index";
import { ConvertToRegisterUserRequest, PrepareToInsertUserProfileConsentModel } from "@/service/user/userFacade";
import store from "@/store/index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Register extends VuexModule {
  private registerLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private registerTemplate: any | null = null;
  private acceptInvitationLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private acceptInvitationModel: any | null = null;
  private insertUserProfileConsentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private registerModel: any | null = null;
  private userProfileConsentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private userProfileConsentModel: any | null = null;

  get getRegisterLoadingStatus(): LoadingStatusType {
    return this.registerLoadingStatus;
  }

  get getUserProfileConsentLoadingStatus(): LoadingStatusType {
    return this.userProfileConsentLoadingStatus;
  }

  get getUserProfileConsentModel(): any {
    return this.userProfileConsentModel;
  }

  get getRegister(): any {
    return this.registerTemplate;
  }

  get getAcceptInvitationLoadingStatus(): LoadingStatusType {
    return this.acceptInvitationLoadingStatus;
  }

  get getAcceptInvitationModel(): any {
    return this.acceptInvitationModel;
  }

  get getInsertUserProfileConsentLoadingStatus(): any {
    return this.insertUserProfileConsentLoadingStatus;
  }

  get getRegisterModel(): any {
    return this.registerModel;
  }

  @Mutation
  public SetRegisterLoadingStatus(status: LoadingStatusType) {
    this.registerLoadingStatus = status;
  }

  @Mutation
  public SetRegisterTemplate(registerTemplate: any) {
    this.registerTemplate = registerTemplate;
  }

  @Mutation
  public SetUserProfileConsentLoadingStatus(status: LoadingStatusType) {
    this.userProfileConsentLoadingStatus = status;
  }

  @Mutation
  public SetUserProfileConsentModel(userProfileConsentModel: any) {
    this.userProfileConsentModel = userProfileConsentModel;
  }

  @Mutation
  public SetAcceptInvitationLoadingStatus(status: LoadingStatusType) {
    this.acceptInvitationLoadingStatus = status;
  }

  @Mutation
  public SetAcceptInvitationModel(acceptInvitationModel: any) {
    this.acceptInvitationModel = acceptInvitationModel;
  }

  @Mutation
  public MutationSetInsertUserProfileConsentLoadingStatus(status: LoadingStatusType) {
    this.insertUserProfileConsentLoadingStatus = status;
  }

  @Mutation
  public MutationGetRegisterModel(registerModel: any) {
    this.registerModel = registerModel;
  }

  @Action DoRegisterEmail(registerTemplate: any) {
    if (this.registerLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetRegisterLoadingStatus", LoadingStatusType.Loading);
      const userProfileModel = ConvertToRegisterUserRequest(registerTemplate);
      API.UserService.DoRegister(userProfileModel).then((res) => {
        if (res.data.responseCode == HttpStatusCode.OK) {
          this.context.commit("SetRegisterTemplate", registerTemplate);
          const registerModel = {
            userId: res.data.insertedUser.userId,
            loginModel: {
              username: registerTemplate.email.value,
              password: registerTemplate.password.value,
              userType: UserType.Email,
              language: i18n.locale,
              register: true,
            },
          };
          this.context.commit("MutationGetRegisterModel", registerModel);
          this.context.commit("SetRegisterLoadingStatus", LoadingStatusType.Success);
        } else {
          this.context.commit("SetRegisterLoadingStatus", LoadingStatusType.Fail);
        }
      });
    }
  }

  @Action DoAcceptInvitation(input: any) {
    if (this.registerLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetAcceptInvitationLoadingStatus", LoadingStatusType.Loading);
      API.UserService.DoAcceptInvitation(input).then((res) => {
        if (res.status.IsSuccess()) {
          this.context.commit("SetAcceptInvitationModel", res.data.invitationModel);
        }
        this.context.commit("SetAcceptInvitationLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action DoInsertUserProfileConsentForRegister(input: any) {
    if (this.insertUserProfileConsentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetInsertUserProfileConsentLoadingStatus", LoadingStatusType.Loading);
      const _input = PrepareToInsertUserProfileConsentModel({
        userId: input.registerModel.userId,
        isConsentTerm: input.isConsentTerm,
      });
      API.UserService.DoInsertUserProfileConsent(_input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          store.dispatch("LogIn/DoLogIn", input.registerModel.loginModel);
          this.context.commit("MutationSetInsertUserProfileConsentLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }

  @Action DoInsertUserProfileConsent(input: any) {
    if (this.insertUserProfileConsentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetInsertUserProfileConsentLoadingStatus", LoadingStatusType.Loading);
      const _input = PrepareToInsertUserProfileConsentModel({
        userId: input.userId,
        isConsentTerm: input.isConsentTerm,
      });
      API.UserService.DoInsertUserProfileConsent(_input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationSetInsertUserProfileConsentLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }

  @Action DoGetUserProfileConsent(userId: any) {
    if (this.insertUserProfileConsentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetUserProfileConsentLoadingStatus", LoadingStatusType.Loading);
      API.UserService.DoGetUserProfileConsent(userId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("SetUserProfileConsentLoadingStatus", LoadingStatusType.Success);
          this.context.commit("SetUserProfileConsentModel", res.data.userprofileConsentModel);
        }
      });
    }
  }

  @Action
  public DoValidateUsername(username: string): Promise<boolean> {
    return new Promise((resolve) => {
      API.UserService.DoValidateUsername(username).then((res) => {
        if (res.status.IsSuccess() && res.data.responseCode.IsSuccess()) {
          resolve(res.data.validated);
        } else {
          resolve(false);
        }
      });
    });
  }
}
